import { ConfirmDialog } from '@roc/ui';
import { useDrawsStore } from '@roc/feature-draws';
import { observer } from 'mobx-react';

export const FreezeFunding = observer(({ loanId }) => {

  const { drawStore: { drawActionsStore } } = useDrawsStore();

  return (
    <ConfirmDialog
      open={drawActionsStore.isFreezeFundingDialogOpen}
      confirmButtonText='Confirm'
      handleClose={() => drawActionsStore.setIsFreezeFundingDialogOpen(false)}
      handleCancel={() => drawActionsStore.setIsFreezeFundingDialogOpen(false)}
      handleConfirm={() => drawActionsStore.switchFreezeFunding(loanId)}
      title={'Freeze Funding'}
      body={`Are you sure you want to change the freeze funding status for this loan?`}
    />
  );
});
